
export function getProductColor(productName: string): string {
  const baseColors: Record<string, string> = {
    corn: '#4CAF50',
    wheat: '#FFA726',
    potatoes: '#8D6E63',
    rice: '#42A5F5',
    barley: '#7E57C2',
    vegetables: '#26A69A',
    fruits: '#EC407A',
    coffee: '#5D4037',
    teff: '#9CCC65',
  };
  
  if (baseColors[productName.toLowerCase()]) {
    return baseColors[productName.toLowerCase()];
  }
  
  let hash = 0;
  for (let i = 0; i < productName.length; i++) {
    hash = productName.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    color += ('00' + value.toString(16)).substr(-2);
  }
  
  return color;
}
